import moment from 'moment';
import I18n from 'app/config/i18n';

export const DatetimeFormatter = ({ value }) => {
  if (value) {
    return moment(value).format('L');
  }
  return I18n.t('base.labels.n_a');
};
